export default function ThreeDotIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.9974 9.58301C10.4576 9.58301 10.8307 9.95609 10.8307 10.4163C10.8307 10.8766 10.4576 11.2497 9.9974 11.2497C9.53715 11.2497 9.16406 10.8766 9.16406 10.4163C9.16406 9.95609 9.53715 9.58301 9.9974 9.58301Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.9974 4.58301C10.4576 4.58301 10.8307 4.95611 10.8307 5.41634C10.8307 5.87657 10.4576 6.24967 9.9974 6.24967C9.53715 6.24967 9.16406 5.87657 9.16406 5.41634C9.16406 4.95611 9.53715 4.58301 9.9974 4.58301Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.9974 14.583C10.4576 14.583 10.8307 14.9561 10.8307 15.4163C10.8307 15.8766 10.4576 16.2497 9.9974 16.2497C9.53715 16.2497 9.16406 15.8766 9.16406 15.4163C9.16406 14.9561 9.53715 14.583 9.9974 14.583Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
